import { useEffect, useRef, useState } from "react";
import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { GeoItem } from 'src/models/geoItem';
import { ITpe } from 'src/pages/accueil/model/types';
import { normalizeGenre } from 'src/utils/utilMethods';

const TpeForm = ({
  tpe,
  onSubmit,
  communes = [],
  localities = [],
  setFormRef,
  onCommuneChange
}: {
  tpe: ITpe | null;
  onSubmit: (data: any) => void;
  communes: GeoItem[];
  localities: GeoItem[];
  setFormRef?: (ref: any) => void;
  onCommuneChange?: (communeId: number | null) => void;
}) => {
  const formRef = useRef<HTMLFormElement>(null);

  const [formData, setFormData] = useState<any>({
    name: "",
    code: "",
    type: "TPE Familiale",
    genre: "Masculin",
    anneeCreation: "",
    nbrActif: 0,
    nbrMember: 0,
    nbrWomen: 0,
    commune: "",
    village: "",
  });

  
  useEffect(() => {
    if (setFormRef) {
      setFormRef(formRef.current);
    }
  }, [setFormRef]);

  
  useEffect(() => {
    if (tpe) {
      setFormData({
        name: tpe.name ?? "",
        code: tpe.code ?? "",
        type: tpe.type ?? "TPE Familiale",
        genre: normalizeGenre(tpe.genre) || "Masculin",
        anneeCreation: tpe.anneeCreation 
  ? new Date(tpe.anneeCreation).toISOString().split('T')[0] 
  : "",
        nbrActif: tpe.nbrActif ?? 0,
        nbrMember: tpe.nbrMember ?? 0,
        nbrWomen: tpe.nbrWomen ?? 0,
        commune: tpe.commune?.id ?? "",
        village: tpe.village?.id ?? "",
      });
      if (onCommuneChange) {
        onCommuneChange(tpe.commune?.id ?? null);
      }
    }
  }, [tpe, onCommuneChange]);

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCommuneChange = (e: any) => {
    const { value } = e.target;
    setFormData({ ...formData, commune: value, village: "" });
    if (onCommuneChange) {
      onCommuneChange(value ? Number(value) : null);
    }
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    e.stopPropagation();

    const payload = {
      ...formData,
      nbrActif: Number(formData.nbrActif),
      nbrMember: Number(formData.nbrMember),
      nbrWomen: Number(formData.nbrWomen),
      commune: { id: Number(formData.commune) },
      village: { id: Number(formData.village) },
    };

    onSubmit(payload);
  };

  return (
    <Form id="tpeForm" onSubmit={handleSubmit}>
      <Row>

        <Col md="6">
          <FormGroup>
            <Label>Type</Label> 
            <Input type="select" name="type" value={formData.type} onChange={handleChange}>
              <option value="TPE Familiale">TPE Familiale</option>
              <option value="Organisation Professionnelle">Organisation Professionnelle</option>
              <option value="Coopérative">Coopérative</option>
              <option value="Association">Association</option>
              <option value="Entreprise Individuelle">Entreprise Individuelle</option>
            </Input>
          </FormGroup>
        </Col>

        <Col md="6">
          <FormGroup>
            <Label>Nom</Label>
            <Input name="name" value={formData.name} onChange={handleChange} />
          </FormGroup>
        </Col>

        <Col md="6">
          <FormGroup>
            <Label>Code</Label>
            <Input name="code" value={formData.code} readOnly />
          </FormGroup>
        </Col>

        <Col md="6">
          <FormGroup>
            <Label>Année de création</Label>
            <Input
              type="date"
              name="anneeCreation"
              value={formData.anneeCreation}
              readOnly
            />
          </FormGroup>
        </Col>

        <Col md="6">
          <FormGroup>
            <Label>Commune</Label>
            <Input type="select" name="commune" value={formData.commune} onChange={handleCommuneChange}>
              <option value="">-- Choisir --</option>
              {communes.map((c: GeoItem) => (
                <option key={c.id} value={c.id}>{c.name}</option>
              ))}
            </Input>
          </FormGroup>
        </Col>

        <Col md="6">
          <FormGroup>
            <Label>Localité</Label>
            <Input type="select" name="village" value={formData.village} onChange={handleChange}>
              <option value="">-- Choisir --</option>
              {localities.map((l: GeoItem) => (
                <option key={l.id} value={l.id}>{l.name}</option>
              ))}
            </Input>
          </FormGroup>
        </Col>

        {formData.type === "TPE Familiale" ? (
          <>
            <Col md="6">
              <FormGroup>
                <Label>Genre</Label>
                <Input type="select" name="genre" value={formData.genre} onChange={handleChange}>
                  <option value="Masculin">Masculin</option>
                  <option value="Féminin">Féminin</option>
                </Input>
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label>Nombre Actif</Label>
                <Input
                  type="number"
                  name="nbrActif"
                  value={formData.nbrActif}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>
          </>
        ) : (
          <>
            <Col md="6">
              <FormGroup>
                <Label>Membres</Label>
                <Input
                  type="number"
                  name="nbrMember"
                  value={formData.nbrMember}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>
            <Col md="6">

              <FormGroup>
                <Label>Femmes</Label>
                <Input
                  type="number"
                  name="nbrWomen"
                  value={formData.nbrWomen}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>
          </>
        )}

      </Row>
    </Form>
  );
};

export default TpeForm;